// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"social","903":"games"}[chunkId] + "." + {"443":"f109bc2f","903":"3afe1de2"}[chunkId] + ".css";
};